import bonusesShuffleFloatLeft from "../../../../resources/bonusesShuffleFloatLeft.png";
import bonusesShuffleFloatRight from "../../../../resources/bonusesShuffleFloatRight.png";
import {NavLink} from "react-router-dom";
import React from "react";
import bonusesRollFloatLeft from "../../../../resources/bonusesLuxdropLeft.png";
import bonusesRollFloatRight from "../../../../resources/bonusesLuxdropRight.png";

const LuxdropRewards = () => {

    return (<div className="landingBonus luxdrop">
        <img src={bonusesRollFloatLeft} className={'floatingTopLeft floating'} alt=""/>
        <img src={bonusesRollFloatRight} className={'floatingTopRight floatingC'} alt=""/>
        <div className="landingBonusContent">
            <div className="textTop">
                FREE BOXES
            </div>
            <div className="textBody">
                <div className="signupSteps">
                    <div className="signupStep">
                        <div className="stepNumber">
                            <div className="stepWrapper">1</div>
                        </div>
                        <div className="stepContent">Sign Up under code <span
                            className="white">“Kazlic”</span> or click the button to instantly
                            Register
                        </div>
                    </div>
                    <div className="signupStep">
                        <div className="stepNumber">
                            <div className="stepWrapper">2</div>
                        </div>
                        <div className="stepContent">You will receive access to <span className="white">3x FREE BOXES</span>
                        </div>
                    </div>
                    <div className="signupStep">
                        <div className="stepNumber">
                            <div className="stepWrapper">3</div>
                        </div>
                        <div className="stepContent">Every active player will be able to participate
                            in <span className="white">the leaderboard</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ctaButton">
                <NavLink to="https://luxdrop.com/r/kazlic" target={"_blank"}
                         className="btn btn-luxdrop w-100">JOIN NOW</NavLink>
            </div>
        </div>
    </div>);

}
export default LuxdropRewards;